export const scheduleIdle = (callback, timeout = 1500) => {
    if (typeof window === 'undefined') {
        callback();
        return () => {};
    }

    if ('requestIdleCallback' in window) {
        const id = window.requestIdleCallback(callback, { timeout });
        return () => window.cancelIdleCallback(id);
    }

    const id = window.setTimeout(callback, Math.min(timeout, 300));
    return () => window.clearTimeout(id);
};
